(function () {
    'use strict';

    angular
        .module('app.home')
        .component('sc3Activities', {
            templateUrl: 'app/home/activities/activities.component.html',
            controller: ActivitiesComponent,
            bindings: {
                data: '<'
            }
        });

    var noop = angular.noop;

    ActivitiesComponent.$inject = ['Member', 'DataSource', 'addActivityModal', 'golfActivityType', 'confirm', 'alert', 'home_resources'];
    function ActivitiesComponent(Member, DataSource, addActivityModal, golfActivityType, confirm, alert, resources) {
        var ctrl = this;

        ctrl.$onInit = init;
        ctrl.getColumnClass = getColumnClass;
        ctrl.sort = sort;
        ctrl.showAddActivityModal = showAddActivityModal;
        ctrl.deleteActivity = deleteActivity;

        //////////////////////////////////////////

        function init() {
            var data = ctrl.data;
            ctrl.dataSource = new DataSource({
                data: data,
                read: getData,
                pageSize: data.pageSize,
                params: {
                    individualId: data.individualId
                }
            });
        }

        function getColumnClass(field) {
            var sort = ctrl.dataSource.sort;
            return sort && sort.field === field ? sort.dir === 'desc' ? 'sort-link-desc' : 'sort-link-asc' : null;
        }

        function getData(options) {
            return Member.getActivities(options, success, error, true);

            function success(data) {
                ctrl.activities = data;
            }

            function error(rejection) {
                var isCancellation = rejection && rejection.status === -1;
                if (!isCancellation)
                    alert.error(resources.activitiesRequestFailed);
            }
        }

        function sort(field) {
            var dataSource = ctrl.dataSource,
                sort = dataSource.sort;
            dataSource.sort = !sort || sort.field !== field ? { field: field, dir: 'asc' } : sort.dir === 'asc' ? {
                field: field, dir: 'desc'
            } : null;
        }

        function showAddActivityModal() {
            var individualId = ctrl.data.individualId,
                activity = { individualId: individualId, date: new Date() };

            addActivityModal(activity).result.then(save, noop);

            function save(activity) {
                Member.saveActivity(activity, success, error, true);

                function success() {
                    ctrl.dataSource.read();
                }
                function error() {
                    alert.error(resources.activitySaveFailed);
                }
            }
        }
        
        function deleteActivity(activity) {
            var individualId = ctrl.data.individualId;
            confirm(resources.activityDeleteConfirmation).then(deleteActivity, noop);

            function deleteActivity() {
                Member.removeActivity({ individualId: individualId, golfActivityId: activity.id }, success, error, true);

                function success() {
                    ctrl.dataSource.read();
                }
                function error() {
                    alert.error(resources.activityDeleteFailed);
                }
            }
        }
    }
})();